import { ManageUsersPage } from '@edwin-group/people-graphql';
import { create } from 'zustand';

interface ManageStaffState {
  page: ManageUsersPage | null;
}

export const useManageStaffStore = create<ManageStaffState>(() => ({
  page: null,
}));
